import groupBy from 'lodash/groupBy'
import mapValues from 'lodash/mapValues'
import values from 'lodash/values'
import orderBy from 'lodash/orderBy'

export const toPoint = (d) => ({
    angle: d.angle,
    x: d.fence_x,
    y: d.fence_y,
    z: d.fence_height,
    distance: d.fence_distance,
})

export const toMinPoints = (data, field) => {
    const byAngle = groupBy(data, 'angle')
    const orderedByField = mapValues(byAngle, (d) => orderBy(d, field))
    const points = values(mapValues(orderedByField, (d) => d[0]))
    const ordered = orderBy(points, 'angle')

    // console.log('byAngle', byAngle);
    // console.log('orderedByField', orderedByField);
    // console.log('ordered', ordered);

    return ordered.map(toPoint)
}

export const toMaxPoints = (data, field) => {
    const byAngle = groupBy(data, 'angle')
    const orderedByAttribute = mapValues(byAngle, (d) => orderBy(d, field))
    const points = values(mapValues(orderedByAttribute, (d) => d[d.length - 1]))
    const ordered = orderBy(points, 'angle')

    return ordered.map(toPoint)
}
